'use client';

interface OrderItem {
  name: string;
  options?: string; // 예: "오곡바게트(+1,000원)"
  price: number;
  quantity: number;
}

interface OrderSummaryProps {
  items: OrderItem[];
  totalAmount: number;
}

export default function OrderSummary({ items, totalAmount }: OrderSummaryProps) {
  return (
    <div className="space-y-4">
      <h2 className="text-lg font-semibold text-neutral-800">예약한 상품</h2>
      <div className="bg-white rounded-lg overflow-hidden">
        {items.map((item, index) => (
          <div key={index} className="h-[118px] border-b border-neutral-100 flex items-center gap-3 last:border-b-0">
            <div className="flex-1 flex flex-col justify-start items-start gap-2">
              <div className="self-stretch flex flex-col justify-start items-start gap-2">
                <div className="self-stretch flex flex-col justify-center text-neutral-700 text-lg font-semibold leading-[26px]">
                  {item.name}
                </div>
                {item.options && (
                  <div className="self-stretch flex flex-col justify-center text-neutral-500 text-sm font-medium leading-[22px]">
                    {item.options}
                  </div>
                )}
              </div>
              <div className="flex justify-start items-start gap-0.5">
                <div className="flex flex-col justify-center text-neutral-700 text-lg font-semibold leading-[26px]">
                  {(item.price * item.quantity).toLocaleString()}
                </div>
                <div className="flex flex-col justify-center text-neutral-700 text-base font-semibold leading-6">
                  원
                </div>
              </div>
            </div>
            <div className="flex justify-start items-center gap-1">
              <div className="text-center text-neutral-800 text-base font-semibold leading-6">{item.quantity}</div>
              <div className="text-center text-neutral-800 text-base font-semibold leading-6">개</div>
            </div>
          </div>
        ))}
        <div className="py-5">
          <div className="flex justify-between items-center">
            <span className="text-lg font-bold text-neutral-800">합계</span>
            <span className="text-lg font-bold text-neutral-800">{totalAmount.toLocaleString()}원</span>
          </div>
        </div>
      </div>
    </div>
  );
}
